import { getAuthToken } from "./localStorage.util";

export const isUserLoggedIn = () => {
  if (!!getAuthToken()) {
    return true;
  }
  return false;
};
